// plugins/sentry.ts
import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin((nuxtApp) => {
  const isNotPrd = useRuntimeConfig()?.public?.mode !== 'production'

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn: 'https://981c0962db07e8189b7ede041392ce82@sentry.sktapollo.com/41',
    environment: useRuntimeConfig()?.public?.mode,
    release: useRuntimeConfig()?.public?.sentryRelease as string | '',
    dist: '1',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false
      })
    ],
    // Performance Monitoring
    tracesSampleRate: 0.001, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],

    // Session Replay
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: isNotPrd ? 0.01 : 0.001,
    beforeSend(event) {
      event.exception?.values?.forEach((ex) => {
        ex.stacktrace?.frames?.forEach((frame) => {
          if (!frame.filename) return

          const fn = frame.filename
            .replace(/^https?:\/\/[^/]+/, '')
            .replace(/^~\/client/, '')
            .replace(/^\/?_?nuxt/, '')
            .replace(/^~\//, '')
            .replace(/^\//, '')

          // fn이 'ceYrJgXm.js' 형태가 되도록
          const fileOnly = fn.split('/').pop()

          // 앞에 '/'를 붙여 '/ceYrJgXm.js' 형태로
          frame.filename = `/${fileOnly}`
        })
      })
      return event
    }
  })
})
